/**
 * /app/tax — tenant-wide entry into the tax certificates page.
 *
 * Replaced the legacy fixture redirect (hardcoded 'vandermerwe-family-trust').
 */

import { createFileRoute } from '@tanstack/react-router';
import { TrustScopedLanding } from '../../components/screens/trust-scoped-landing';

export const Route = createFileRoute('/app/tax')({
  component: () => (
    <TrustScopedLanding
      suffix="tax"
      eyebrow="Tax"
      title="Tax"
      emptyHelp="Tax certificates (IT3(t), beneficiary distribution statements, dividend tax certificates) appear here per tax year. They are generated by your accountant or the in-platform tax module once a trust has tax-relevant activity."
    />
  ),
});
